import CreatePromotionAction from '../../prat_actions/promotion/createPromotionAction'

const CreatePromotionReducer = (state = {
    isCreatePromotionLoading: true, promotionResponse: false,error:undefined,draftData:undefined,
    promotionData: undefined, promotionMtftsData: undefined,calcError:undefined,isCreatePromotionError:undefined,
}, action) => {
    // let details;
    // console.log(action.type)
    switch (action.type) {

        case CreatePromotionAction.CREATE_PROMOTION_REQUEST:
            return {
                ...state,
                isCreatePromotionError: undefined,
                productDetail: action.data,
            };

        case CreatePromotionAction.CREATE_PROMOTION_SUCCESS:
            return {
                ...state,
                isCreatePromotionLoading: false,
                promotionResponse: true,
                promotionData: action.data,
                
            };

        case CreatePromotionAction.CREATE_PROMOTION_FAILED:
            return {
                ...state,
                isCreatePromotionError: action.error,
                // error: action.error,
            };
      
            //CREATE PROMOTION MTFTS
        case CreatePromotionAction.CREATE_PROMOTION_MTFTS_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: false,
                productDetail: action.data,
            };

        case CreatePromotionAction.CREATE_PROMOTION_MTFTS_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isCreatePromotionLoading: false,
                promotionResponse: true,
                promotionData: action.data
            };

        case CreatePromotionAction.CREATE_PROMOTION_MTFTS_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: false,
                error: action.error
            };

        // New Draft

        case CreatePromotionAction.New_DRAFT_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: false,
                newDraft: action.data,
            };

        case CreatePromotionAction.New_DRAFT_SUCCESS:
            // console.log(action.data,action.formtype,"action.type")
            return {
                ...state,
                isCreatePromotionLoading: false,
                promotionResponse: true,
                newDraft: action.data,
                error: undefined
            };

        case CreatePromotionAction.New_DRAFT_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: 'draft_error',
                error: action.error,
                type:''
            };

        // Save Draft

        case CreatePromotionAction.SAVE_DRAFT_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: false,
                productDetail: action.data,
            };

        case CreatePromotionAction.SAVE_DRAFT_SUCCESS:
            return {
                ...state,
                isCreatePromotionLoading: false,
                promotionResponse: true,
                draftData: action.data,
                isExtended:action.data?.isExtended,
                error: undefined

            };

        case CreatePromotionAction.SAVE_DRAFT_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: 'draft_error',
                error: action.error
            };

        // Get All enum

        case CreatePromotionAction.GET_ALL_ENUM_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: false,
                enumData: action.data,
            };

        case CreatePromotionAction.GET_ALL_ENUM_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isCreatePromotionLoading: false,
                enumData: action.data,
            };

        case CreatePromotionAction.GET_ALL_ENUM_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: false,
                error: action.error
            };

        // Post Calculate Pre Opsp

        case CreatePromotionAction.POST_CALCULATE_PREOPSO_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: true,
                calculateedData: action.data,
                extendedNewPromotion:false,

            };

        case CreatePromotionAction.POST_CALCULATE_PREOPSO_SUCCESS:
            return {
                ...state,
                isCreatePromotionLoading: false,
                calculatedData: action.data,
                extendedNewPromotion:true,
                newExtensionData:action.data
                // draftData.PreOpso:action.data,
            };

        case CreatePromotionAction.POST_CALCULATE_PREOPSO_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: false,
                calcError: action.error,
                extendedNewPromotion:false,

                // calculatedData: action.data,


            };

        // Post new Project Pre Opsp

        case CreatePromotionAction.POST_NEWPROJECT_PREOPSO_REQUEST:
            return {
                ...state,
                isCreatePromotionLoading: false,
                newProject: action.data,
            };

        case CreatePromotionAction.POST_NEWPROJECT_PREOPSO_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isCreatePromotionLoading: false,
                newProject: action.data,
            };

        case CreatePromotionAction.POST_NEWPROJECT_PREOPSO_FAILED:
            return {
                ...state,
                isCreatePromotionLoading: false,
                newProject: action.error
            };

            // PUSH TO DWH 

            case CreatePromotionAction.PUSH_TO_DWH_REQUEST:
                return {
                    ...state,
                    isCreatePromotionLoading: false,
                    pushToDwh: action.data,
                };
    
            case CreatePromotionAction.PUSH_TO_DWH_SUCCESS:
                return {
                    ...state,
                    is_push_to_dwh_loading: false,                    
                    pushToDwh: action.data,
                    
                };
    
            case CreatePromotionAction.PUSH_TO_DWH_FAILED:
                return {
                    ...state,
                    is_push_to_dwh_loading: false,
                    error: action.error,
                };
            

        default:
            return {
                ...state
            };
    }
}

export default CreatePromotionReducer;